import { render } from "./applicationWeb.vue?vue&type=template&id=1f9bf33e"
import script from "./applicationWeb.vue?vue&type=script&lang=js"
export * from "./applicationWeb.vue?vue&type=script&lang=js"

import "./applicationWeb.vue?vue&type=style&index=0&id=1f9bf33e&lang=scss&scpoed=true"
script.render = render

export default script